import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NasModelModule } from '@sama/ng-app-state';
import { isUndefined } from 'lodash';
import { map } from 'rxjs';
import { TaskWorkspaceStore } from '../../../../../core/h3ml/state/task-workspace-store';
import { FeatureFlagService } from '../../../../../core/shared/misc-services/feature-flag.service';
import { TrackingEvent } from '../../../../../cross-team-shared/event-tracking/event-utils';
import { isVideoOutput } from '../../../../../cross-team-shared/misc-utils/output-utils';
import { defaultRegionOfInterestDistance } from '../../../../../cross-team-shared/state/region-of-interest-state';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';
import { NumericInputSettingsComponent } from '../numeric-input-settings/numeric-input-settings.component';

@Component({
  selector: 'h3-region-of-interest-distance',
  templateUrl: './region-of-interest-distance.component.html',
  styleUrl: './region-of-interest-distance.component.scss',
  imports: [
    NasModelModule,
    MatButtonToggleModule,
    AsyncPipe,
    NumericInputSettingsComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionOfInterestDistanceComponent {
  private readonly store = inject(TaskWorkspaceStore);
  private readonly featureFlagService = inject(FeatureFlagService);

  protected defaultValue = defaultRegionOfInterestDistance;

  protected isSplitViewDisabled$ = this.store('splitViewOutputName').$.pipe(
    map(isUndefined),
  );

  protected trackingEvent: TrackingEvent = {
    id: 'adjust_roi_distance',
    bucket: 'navigation',
    sub_bucket: 'frame',
  };

  protected cameraRoiDistanceStore = inject(settingsStoreToken)(
    'regionOfInterestSettings',
  );

  protected videoOutputs = this.store
    .state()
    .project.outputs.filter(
      (output) =>
        isVideoOutput(output) && !output.meta.is_orthographic_projection,
    );

  protected hasRoiPerOutputFeatureFlag =
    this.featureFlagService.hasFlag('roi_per_output_on');
}
